import React from 'react';
import './Settings.css';

const Settings = () => {
  return (
    <div className='settings'>
      <h1>Settings</h1>
      <p>
        Adjust your account preferences and application settings. Coming soon.
      </p>
    </div>
  );
};

export default Settings;
